import axios from 'axios';
import { API_URL } from '@App/app.constants';

function fetchFile(href, onDownloadProgress) {
  return axios.get(href, { 
    responseType: 'blob',
    onDownloadProgress: (progressEvent) => {
      onDownloadProgress(Math.round((progressEvent.loaded * 100) / progressEvent.total))
    },
  })
}

function getSearchAutocompleteData(input) {
  return axios.get(`${API_URL}/api/search/autocomplete?requiredParam=${input}`)
    .then(result => result.data);
}

function getSearchPlaceData(input) {
  return axios.get(`${API_URL}/api/search/geocode?requiredParam=${input}`)
    .then(result => result.data);
}

function getReverseGeocodeData(lat, lng) {
  return axios.get(`${API_URL}/api/search/reverse-geocode?lat=${lat}&lng=${lng}`)
    .then(result => result.data);
}

export {
  fetchFile,
  getSearchAutocompleteData,
  getSearchPlaceData,
  getReverseGeocodeData,
}